import { Badge, Button } from "react-bootstrap";
import styles from "./index.module.scss";

const Item = ({ userId, comment, isFriend, onDelete, isDeleting }) => {
  return (
    <div className={styles.item}>
      <div className={styles.itemInfo}>
        <div className={styles.userRow}>
          <div className={styles.userId}>{userId}</div>
          {isFriend && <Badge className={styles.friendBadge}>Друг</Badge>}
        </div>
        {comment && <div className={styles.comment}>{comment}</div>}
      </div>
      <Button
        className={styles.deleteButton}
        variant="outline-danger"
        aria-label={`Видалити користувача ${userId} з White List`}
        disabled={isDeleting}
        onClick={() => onDelete(userId)}
      >
        {isDeleting ? (
          <>
            <span
              className="spinner-border spinner-border-sm"
              aria-hidden="true"
            />
            <span>Видалення...</span>
          </>
        ) : (
          <>
            <i className="bi bi-trash" aria-hidden="true" />
            <span>Видалити</span>
          </>
        )}
      </Button>
    </div>
  );
};

export default Item;
